import { ID, MergedFlightWithContext } from "@nova/constants"
import { MergedFlight } from "@nova/protobuf"
import { createSelector } from "@reduxjs/toolkit"
import { RootState } from "integrations/redux/rootReducer"
import { memoize } from "nodash"
import { selectInfraredFlights } from "../flights/selectors"

const root = (state: RootState) => state.project.data.mergedFlights

export const selectMergedFlights = createSelector(
    [root, selectInfraredFlights],
    (mergedFlights, infraredFlights) => {
        return mergedFlights.map((mergedFlight: MergedFlight) => {
            const flightsInMerge = infraredFlights.filter(
                (flight) => flight.mergeId === mergedFlight.id
            )
            const flightIdsInMerge = flightsInMerge.map((flight) => flight.id)
            return {
                ...mergedFlight,
                hotspotFlightIds: flightIdsInMerge,
                hotspotFlights: flightsInMerge,
                hotspots: flightsInMerge.flatMap((flight) => flight.hotspots),
            }
        }) as MergedFlightWithContext[]
    }
)

export const selectMergedFlightsMap = createSelector([selectMergedFlights], (mergedFlights) => {
    return mergedFlights.reduce(
        (acc, cur) => {
            acc[cur.id] = cur
            return acc
        },
        {} as Record<string, MergedFlightWithContext>
    )
})

export const selectMergedFlightById = memoize((mergeId: ID) =>
    createSelector([selectMergedFlightsMap], (mergedFlights) => {
        return mergedFlights[mergeId]
    })
)

export const selectGroupById = memoize((groupId: string) =>
    createSelector([selectMergedFlightsMap], (groupMap) => groupMap[groupId])
)

export const selectUnmergedInfraredFlights = createSelector(
    [selectInfraredFlights, selectMergedFlightsMap],
    (flights, mergedFlights) => {
        return flights.filter(
            (flight) => !flight.mergeId || (!!flight.mergeId && !mergedFlights[flight.mergeId])
        )
    }
)
export const selectUnmergedNonArchivedInfraredFlights = createSelector(
    [selectUnmergedInfraredFlights],
    (flights) => flights.filter((flight) => !flight.archivedTimestamp)
)
